import { createActionTypes } from "@helpers/redux-helpers";

export const getScheduledPostsActionTypes = createActionTypes(
  "scheduled_posts/getList",
);

export const deleteScheduledPostActionTypes = createActionTypes(
  "scheduled_posts/delete",
);

export const getPortionScheduledActionTypes = createActionTypes(
  "scheduled_posts/getPortion",
);

export const addPendingEditingScheduledPostActionType =
  "scheduled_posts/addPendingEditing";

export const removePendingEditingScheduledPostActionType =
  "scheduled_posts/removePendingEditing";

export const updateScheduledPostActionType = "scheduled_posts/update";

export const scheduledPostUploadedActionType = "scheduled_posts/postUploaded";

export const setScheduledPostsActionTypes = createActionTypes(
  "scheduled_posts/set",
);

export const editScheduledPostActionTypes = createActionTypes(
  "scheduled_posts/edit",
);
